import React, { useRef } from 'react';
import { useIntl } from 'react-intl-next';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { ToolbarButton, ToolbarTooltip, ImageIcon } from '@atlaskit/editor-toolbar';
import { fg } from '@atlaskit/platform-feature-flags';
export var MediaButton = function MediaButton(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['media', 'connectivity'], function (states) {
      var _states$mediaState, _states$mediaState2, _states$connectivityS;
      return {
        showMediaPicker: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.showMediaPicker,
        allowsUploads: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.allowsUploads,
        connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
      };
    }),
    showMediaPicker = _useSharedPluginState.showMediaPicker,
    connectivityMode = _useSharedPluginState.connectivityMode,
    allowsUploads = _useSharedPluginState.allowsUploads;
  var mediaButtonRef = useRef(null);
  if (!(api !== null && api !== void 0 && api.media)) {
    return null;
  }
  var onClick = function onClick() {
    var _api$mediaInsert, _api$analytics;
    if (!showMediaPicker) {
      return;
    }
    if (api !== null && api !== void 0 && (_api$mediaInsert = api.mediaInsert) !== null && _api$mediaInsert !== void 0 && (_api$mediaInsert = _api$mediaInsert.commands) !== null && _api$mediaInsert !== void 0 && _api$mediaInsert.showMediaInsertPopup && fg('platform_editor_add_media_from_url_rollout')) {
      var _api$core, _api$mediaInsert2;
      var mountInfo = mediaButtonRef.current ? {
        ref: mediaButtonRef.current,
        mountPoint: mediaButtonRef.current
      } : undefined;
      api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$mediaInsert2 = api.mediaInsert) === null || _api$mediaInsert2 === void 0 ? void 0 : _api$mediaInsert2.commands.showMediaInsertPopup(mountInfo));
    } else {
      showMediaPicker();
    }
    api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
      action: ACTION.OPENED,
      actionSubject: ACTION_SUBJECT.PICKER,
      actionSubjectId: fg('platform_editor_add_media_from_url_rollout') ? ACTION_SUBJECT_ID.PICKER_MEDIA : ACTION_SUBJECT_ID.PICKER_CLOUD,
      attributes: {
        inputMethod: INPUT_METHOD.TOOLBAR
      },
      eventType: EVENT_TYPE.UI
    });
  };
  var isOffline = connectivityMode === 'offline';
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: formatMessage(messages.addMediaFiles)
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(ImageIcon, {
      label: formatMessage(messages.addMediaFiles),
      size: "small"
    }),
    onClick: onClick,
    ref: mediaButtonRef,
    isDisabled: isOffline || !allowsUploads
  }));
};